export const providerChk = {
    isKakao : (providerId)=>{
        if(providerId == "kakao" || providerId == "cokakao"){
            return true;
        }else{
            return false;
        }
    },
    isNaver : (providerId)=>{
        if(providerId == "naver" || providerId == "conaver"){
            return true;
        }else{
            return false;
        }
    },
    isSamsung : (providerId)=>{
        if(providerId == "kica" || providerId == "cokica"){
            return true;
        }else{
            return false;
        }
    },
    isKb : (providerId)=>{
        if(providerId == "kb" || providerId == "cokb"){
            return true;
        }else{
            return false;
        }
    },
    isPayco : (providerId)=>{
        if(providerId == "payco" || providerId == "copayco"){
            return true;
        }else{
            return false;
        }
    },
    isToss : (providerId)=>{
        if(providerId == "cotoss-esign" || providerId == "drtoss-esign" || providerId == "toss"){
            return true;
        }else{
            return false;
        }
    },
    isPass : (providerId)=>{
        if(providerId == "pass" || providerId == "copass"){
            return true;
        }else{
            return false;
        }
    },
    isKakaoPay : (providerId)=>{
        if(providerId == "kakaopay" || providerId == "cokakaopay"){
            return true;
        }else{
            return false;
        }
    },
    isShinhan : (providerId)=>{
        if(providerId == "shinhan" || providerId == "coshinhan"){
            return true;
        }else{
            return false;
        }
    },
    isBanksalad : (providerId)=>{
        if(providerId == "banksalad" || providerId == "cobanksalad"){
            return true;
        }else{
            return false;
        }
    },
    isHana : (providerId)=>{
        if(providerId == "hana" || providerId == "cohana"){
            return true;
        }else{
            return false;
        }
    }

}